// extracted by mini-css-extract-plugin
export default {"canvas":"NetCanvas_canvas__-ZiWR"};